import Vue from "vue";
import Router from "vue-router";

const Front = () => import("@/views/Front.vue");
const ArticleViews = () => import("@/views/ArticleViews.vue");
const ArticleView = () => import("@/views/ArticleView.vue");
//search views
const SearchArticle = () => import("@/views/Search/SearchView");
const SearchMenu = () => import("@/views/Search/SearchAside");

const HomeArticle = () => import("@/views/Home/HomeView");
const HomeMenu = () => import("@/views/Home/HomeAside");

// account pages
const Account = () => import("@/views/Account/Account");
const ProfileMain = () => import("@/views/Account/Profile/ProfileMain");
const Profile = () => import("@/views/Account/Profile/Profile");
const ProfileEdit = () => import("@/views/Account/Profile/ProfileEdit");
const PasswordChange = () => import("@/views/Account/Profile/PasswordChange");
const EmailChange = () => import("@/views/Account/Profile/EmailChange.vue");
const Payments = () => import("@/views/Account/Payments");

const Rating = () => import("@/views/Account/Rating");

// personal cabinet pages
const PersonalCabinet = () => import("@/views/PersonalCabinet/PersonalCabinet");
const PersonalNews = () => import("@/views/PersonalCabinet/News");
const PersonalResults = () => import("@/views/PersonalCabinet/EducationResults");
const PersonalFavorites = () => import("@/views/PersonalCabinet/Favorites");
const PersonalHistory = () => import("@/views/Account/PersonalHistory");
const CalculatorsContentSection = () => import("@/views/Account/CalculatorsContentSection");
const NormativeContentSection = () => import("@/views/Account/NormativeContentSection");
const AdditionalContentSection = () => import("@/views/Account/AdditionalContentSection");

//article views
const AsideMenu = () => import("@/views/ArticleAside");
const PostEvdGroup = () => import("@/views/Post/PostEvdGroup");

const EducationMain = () => import("@/views/Education/EducationMain");
const EducationWelcome = () => import("@/views/Education/Nested/Welcome");
const EducationProgramPreview = () => import("@/views/Education/Nested/ProgramPreview");
const EducationResults = () => import("@/views/Education/Nested/Results");
const EducationTestTheme = () =>
  import("@/views/Education/Nested/ThemeArticles");
const EducationTestDescription = () =>
  import("@/views/Education/Nested/Test/TestDescription");
const EducationTestQuiz = () => import("@/views/Education/Nested/Test/Test");
const EducationTestResult = () =>
  import("@/views/Education/Nested/Test/TestResult");
//demo api views
const ApiMain = () => import("@/views/ApiDemo/ApiMain");
const ApiWelcome = () => import("@/views/ApiDemo/ApiWelcome");
const ApiDemo = () => import("@/views/ApiDemo/ApiDemo");
//header main nav pages
const EbmEds = () => import("@/views/EbmEds");
const FreeAlgom = () => import("@/views/FreeAlgom");
const AboutUs = () => import("@/views/AboutUs");
const CovidPatients = () => import("@/views/CovidPatients");
const PageFromPost = () => import("@/views/PageFromPost");
//payment pages
const Price = () => import("@/views/Price");
const PayPlan = () => import("@/views/PayPlan");
//utility pages
const NpsQuiz = () => import("@/views/Utility/NpsQuiz");
const ExternalServer = () => import("@/views/Utility/ExternalServer");
const PasswordConfirm = () => import("@/views/Utility/PasswordConfirmation");
const EmailConfirm = () => import("@/views/Utility/EmailConfirmation");
const Maintenance = () => import("@/views/Utility/Maintenance");
const Forbidden = () => import("@/views/Utility/Forbidden");
const NotFound = () => import("@/views/Utility/NotFound");
const MedxAuth = () => import("@/views/MedxAuth");

Vue.use(Router);

Vue.router = new Router({
  linkExactActiveClass: "exact",
  linkActiveClass: "active",
  mode: "history",
  scrollBehavior(to, from, savedPosition) {
    if (to.hash) {
      return false;
    }
    if (savedPosition) {
      return new Promise((resolve, reject) => {
        setTimeout(() => {
          resolve(savedPosition);
        }, 500);
      });
    } else {
      return { x: 0, y: 0 };
    }
  },
  routes: [
    {
      path: "",
      name: "front",
      component: Front,
      redirect: "/",
      props: true,
      children: [
        // header main-nav views
        {
          path: "medx",
          name: "medx-auth",
          component: MedxAuth,
          props: true,
        },
        {
          path: "personal",
          name: "personal",
          redirect: { name: "news" },
          component: PersonalCabinet,
          meta: {
            auth: true,
            forbiddenRedirect: "/404",
          },
          children:[
            {
              path: "news",
              name: "news",
              component: PersonalNews,
            },
            {
              path: "education-results",
              name: "education-results",
              component: PersonalResults,
            },
            {
              path: "favorites",
              name: "favorites",
              component: PersonalFavorites,
              props: true,
            },
            {
              path: "history",
              name: "history",
              component: PersonalHistory,
              props: true,
            },
            {
              path: "calculators",
              name: "calculators",
              component: CalculatorsContentSection,
              props: true,
            },
            {
              path: "normative-documents",
              name: "normative-documents",
              component: NormativeContentSection,
              props: true,
            },
            {
              path: "additional-materials",
              name: "additional-materials",
              component: AdditionalContentSection,
              props: true,
            },
          ]
        },
        {
          path: "account",
          name: "account",
          redirect: { name: "profile" },
          component: Account,
          meta: {
            auth: true,
            forbiddenRedirect: "/404",
          },
          children: [
            {
              path: "profile",
              name: "",
              component: ProfileMain,
              props: true,
              children: [
                {
                  path: "/",
                  name: "profile",
                  component: Profile,
                  props: true,
                },
                {
                  path: "edit",
                  name: "profile-edit",
                  component: ProfileEdit,
                  props: true,
                },
                {
                  path: "getdemo",
                  name: "profile-getdemo",
                  component: ProfileEdit,
                  props: true,
                },
                {
                  path: "change-password",
                  name: "change-password",
                  component: PasswordChange,
                },
                {
                  path: "change-email",
                  name: "change-email",
                  component: EmailChange,
                },
              ],
            },
            {
              path: "payments",
              name: "payments",
              component: Payments,
              props: true,
            },
            {
              path: "rating",
              name: "rating",
              component: Rating,
              props: true,
            },
          ],
        },
        {
          path: "",
          component: ArticleViews,
          children: [
            {
              path: "/",
              name: "home",
              props: true,
              components: {
                article: HomeArticle,
                menu: HomeMenu,
              },
            },
            {
              path: "dynamed/:code",
              name: "dynamed",
              props: true,
              components: {
                article: ArticleView,
                menu: AsideMenu,
              },
              meta:{
                showDynomedLink:true,
              }
            },
            {
              path: "farm/:code",
              name: "farm",
              props: true,
              components: {
                article: ArticleView,
                menu: AsideMenu,
              },
            },
            {
              path: "mkb/:code",
              name: "mkb",
              props: true,
              components: {
                article: ArticleView,
                menu: AsideMenu,
              },
            },
            {
              path: "post/evdgroup",
              name: "evdgroup",
              components: {
                article: PostEvdGroup,
                menu: AsideMenu,
              },
            },
            {
              path: "post/:code",
              name: "post",
              props: true,
              components: {
                article: ArticleView,
                menu: AsideMenu,
              },
            },
            {
              path: "draft/:code",
              name: "draft",
              props: draft => ({ draft: true}),
              meta: {
                auth: {
                  roles: [
                    "GLOBAL_ADMIN",
                    "ROLE_ADMIN",
                    "ROLE_EDITOR",
                    "ROLE_VALIDATOR",
                    "ALGOM_ADMIN",
                  ],
                  forbiddenRedirect: "/403",
                },
              },
              components: {
                article: ArticleView,
                menu: AsideMenu,
              },
            },
            {
              path: "search/:code",
              name: "search",
              props: true,
              components: {
                article: SearchArticle,
                menu: SearchMenu,
              },
            },
          ],
        },

        {
          path: "/education",
          name: "education",
          component: EducationMain,
          props: true,
          children: [
            {
              path: "results",
              name: "results",
              component: EducationResults,
              props: true,
              meta: {
                auth: true,
              },
            },
            {
              path: "articles/:testId",
              name: "articles",
              component: EducationTestTheme,
              props: true,
              meta: {
                auth: true,
              },
            },
            {
              path: "description/:testId",
              name: "description",
              component: EducationTestDescription,
              props: true,
              meta: {
                auth: true,
              },
            },
            {
              path: "test/:testId/result",
              name: "test-result",
              component: EducationTestResult,
              props: true,
              meta: {
                auth: true,
              },
            },
            {
              path: "test/:testId",
              name: "test",
              component: EducationTestQuiz,
              props: true,
              meta: {
                auth: true,
              },
            },
            {
              path: ":code",
              name: "program",
              component: EducationWelcome,
              props: true,
            },
            {
              path: "preview/:id",
              name: "program-preview",
              component: EducationProgramPreview,
              props: true,
            },
          ],
        },
        {
          path: "algom-api",
          name: "",
          component: ApiMain,
          redirect: { name: "algom-api" },
          children: [
            {
              path: "/",
              name: "algom-api",
              component: ApiWelcome,
            },
            {
              path: "demo",
              name: "demo",
              component: ApiDemo,
              props: true,
            },
          ],
        },
        {
          path: "/oprosnik_nps",
          name: "oprosnik_nps",
          component: NpsQuiz,
        },
        {
          path: "/ebm-eds",
          name: "ebm-eds",
          component: EbmEds,
        },
        {
          path: "/free-algom",
          name: "free-algom",
          component: FreeAlgom,
        },
        {
          path: "/about-us",
          name: "about-us",
          component: AboutUs,
        },
        {
          path: "/covid-patients",
          name: "covid-patients",
          component: CovidPatients,
        },
        {
          path: "/login",
          name: "login",
          redirect: "/",
        },
        {
          path: "/price",
          alias: ["/post/price"],
          name: "price",
          component: Price,
          props: true,
        },
        {
          path: "/price/:plan",
          name: "pay-plan",
          component: PayPlan,
          props: true,
        },
        {
          path: "/confirmation/registration/:token",
          name: "set-password",
          component: PasswordConfirm,
          props: true,
        },
        {
          path: "/confirmation/password/:token",
          name: "reset-password",
          component: PasswordConfirm,
          props: true,
        },
        {
          path: "/confirmation/email/:token",
          alias: ["/confirmation/change-email/:token"],
          name: "set-email",
          component: EmailConfirm,
          props: true,
        },
        {
          path: "/external-server/:token",
          name: "external-server",
          component: ExternalServer,
        },
        {
          path: "/feedback",
          name: "feedback",
          redirect: "/",
        },
        {
          path: "/error",
          name: "maintenance",
          component: Maintenance,
        },
        {
          path: "/403",
          name: "forbidden",
          component: Forbidden,
        },
        {
          path: "/500",
          name: "service",
          component: Maintenance,
        },
        {
          path: "/404",
          name: "not-found",
          component: NotFound,
        },
        {
          path: ":code",
          name: "custom-page",
          component: PageFromPost,
        },
      ],
    },
  ],
});

export default Vue.router;
